import { string } from 'yup';

function isInteger (s) {

	let i;
	for (i = 0; i < s.length; i++) {

		const c = s.charAt(i);
		if (c < '0' || c > '9') {

			return false;

		}

	}
	return true;

}

function stripCharsInBag (s, bag) {

	let i;
	let returnString = '';

	for (i = 0; i < s.length; i++) {

		const c = s.charAt(i);
		if (bag.indexOf(c) === -1) {

			returnString += c;

		}

	}
	return returnString;

}

const rule = {
	name: 'phoneInt',
	method ({ message } = { message: 'Please specify a valid phone number' }) {

		return this.test('phoneInt', message, function (value) {

			const phoneNumberDelimiters = '()- ext.';
			const validWorldPhoneChars = `${phoneNumberDelimiters}+`;
			const minDigitsInIPhoneNumber = 10;
			const s = stripCharsInBag(value, validWorldPhoneChars);
			const valid = isInteger(s) && s.length >= minDigitsInIPhoneNumber;

			const { createError } = this;
			return valid || createError({ message });

		});

	},
	schemaType: string
};

export default rule;
